import { urlFor } from '../../utils/sanity';
export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      urlFor
    };
  },
  methods: {}
};